import React, { useEffect, useState } from 'react'
import organisms from '../../../../components/organisms'
import Wrapper from '../../../../components/common/Wrapper/Wrapper'
import { Stepper, BottomNav } from '../../../../components/common/Stepper/Stepper'
import service from '../../../../api/services'
import { useToasts } from 'react-toast-notifications'
import { useNavigate, useParams } from 'react-router'
import { Store_Legal_Status } from '../../../../constants/defaultValues'
import { getDropdownValue, emailValidation, getStateIdByLabel } from '../../../../constants/utils'
import constant from '../../../../constants/constant'
import molecules from '../../../../components/molecules'
import { TDefaultPermission, TerritoryListProps, TRoleData, TRoleOptional } from './interface'
import { validationRulesStepOne, validationRulesStepThree, validationRulesStepTwo } from './validationRules'
import { City_List, Kuwait_City_List, State_List } from '../../../../constants/state_cities'
import { Region_List } from '../../../../constants/region'
import { Kuwait_State_List } from '../../../../constants/kuwait.state'
import { extractDefaultPermissions } from './usePermission'
import { usePermsData } from './hook/usePermsData'
const { AddStoreOrganism } = organisms
const { TopBar } = molecules
const AddStore = () => {
    const { modifiedStaffPermission } = usePermsData();
    const [step, setStep] = useState(0)
    const [submitClicked, setSubmitClicked] = useState<boolean>(false)
    const [imagesURL, setImagesURL] = useState([])
    const [bannerImagesURL, setBannerImagesURL] = useState([])
    const params = useParams()
    const { addToast } = useToasts();
    const navigate = useNavigate()
    const [errors, setErrors] = useState<any>({});
    const [emailError, setEmailError] = useState<any>({})
    const [imageDeleteID, setImageDeleteId] = useState([])
    const [updateStoreLocation, setUpdateStoreLocation] = useState("");

    //state for store permission
    const [structuredPermission, setStructuredPermission] = useState<any>([]);
    const [defaultPermission, setDefaultPermission] = useState<TDefaultPermission[]>([]);
    //end

    //for staff permission
    const [structuredStaffPermission, setStructuredStaffPermission] = useState<any>([]);
    const [defaultStaffPermission, setDefaultStaffPermission] = useState<TDefaultPermission[]>([]);
    //end

    const [territoryList, setTerritoryList] = useState<TerritoryListProps[] | []>([])
    const [cities, setCities] = useState<any>([]);
    // for role of store
    const [rolesList, setRolesList] = useState<any>();
    const [rolesData, setRolesData] = useState<TRoleData[]>();
    const [selectedRole, setSelectedRole] = useState<TRoleOptional>()
    // end

    // for role for staff
    const [staffRolesList, setStaffRolesList] = useState<any>();
    const [staffRolesData, setStaffRolesData] = useState<TRoleData[]>();
    const [staffSelectedRole, setStaffSelectedRole] = useState<TRoleOptional>()
    //end

    const [storeDetails, setStoreDetails] = useState<any>({
        store_id: "",
        store_code: "",
        store_name: "",
        store_contact_number: '',
        store_address: "",
        ar_store_address:'',
        ar_store_name:'',
        store_location: "",
        city: '',
        store_images: [],
        cover_index: 0,
        state: '',
        pin_code: '',
        owner_name: "",
        owner_mobile: '',
        owner_email: "",
        owner_is_manager: "",
        manager_name: "",
        manager_mobile: '',
        manager_email: "",
        tds: '',
        credit: '',
        latitude: "",
        longitude: "",
        bank_name: "",
        ifsc_code: "",
        account_number: '',
        legal_status: '',
        total_staffs: '',
        additional_charge: '',
        gst_number: '',
        furniture_type: '',
        optometrist_available: '',
        chair_unit_available: '',
        ar_machine_available: '',
        lensometer_available: '',
        slit_lamp: '',
        gst_type: 3,
        gst_document: "",
        pan_number: "",
        pan_document: "",
        gumasta_number: "",
        gumasta_document: "",
        nagar_nigam_number: "",
        nagar_nigam_document: "",
        incorporation_number: "",
        incorporation_document: "",
        agency_number: "",
        agency_document: "",
        admin_username: "",
        admin_name: "",
        admin_password: "",
        store_count: "",
        admin_change_password: "",
        store_admin_id: '',
        is_warehouse: false,
        head_office:false,
        opening_time: '',
        closing_time: '',
        store_banner: [],
        at_your_service_since: "",
        google_rating: NaN,
        online_commission_percent: '',
        number_of_subadmins: '',
        number_of_staff: '',
        region: '',
        admin_permissions: [],
        staff_permissions: [],
        website_url: '',
        role_id:'',
        staff_permission_role_id:''
   
        // stock_ownership:false
    })
    const [adminVerification,setAdminVerification]=useState({
        admin_username:'',
        isAdminExist:false,
        showWaring:false
    })
    const steps = [
        'Basic Details',
        'Profile Details',
        'Store Permission',
        'Staff Permission',
        'Documents',
    ];
    const _handleSubmitBtnClick = () => {
        const isValid = validate();
        if (isValid)
            setSubmitClicked(true)
    };
    useEffect(() => {
        if (submitClicked) {
            _handleSubmit(storeDetails)
        }
        if (!params.id) {
            getStoreCount()
        }
    }, [submitClicked])

    const getStoreCount = async () => {
        let tempStoreDetails = storeDetails
        try {
            let response = await service.store.storeCount()
            if (response.status === 200) {
                tempStoreDetails.store_count = response.data.count
                setStoreDetails(tempStoreDetails)
            }
        } catch (error) {

        }
    }

    const _handleSubmit = async (storeData: any) => {
        const formdata: any = new FormData();
        let multiKey: any = ['legal_status', 'furniture_type', 'city', 'state', 'region']
        for (const key in storeDetails) {
            if (storeDetails.hasOwnProperty(key) && storeData[key] !== undefined &&
                storeData[key] !== '' && storeData[key] !== null) {
                if (multiKey.includes(key)) {
                    formdata.append(key, storeData[key].value)
                } else if (key === 'store_images') {
                    storeData?.store_images.forEach((image: any) => formdata.append('store_images', image));
                } else if (key === 'store_banner') {
                    storeData?.store_banner.forEach((image: string) => formdata.append('store_banner', image));
                } else {
                    formdata.append(key, storeData[key]);
                }
            }
        }

        try {
            if (params?.id) {
                const response = await service.store.updateStoreService(params?.id, formdata, { "Content-type": "multipart/form-data" })
                if (response.status === 200) {
                    navigate('/stores')
                    addToast('Store updated successfully', {
                        appearance: 'success',
                        autoDismiss: true,
                        autoDismissTimeout: 3000,
                    });
                }
            }
            else {
                const response = await service.store.createStoreService(formdata, { "Content-type": "multipart/form-data" })
                if (response.status === 201) {
                    navigate('/stores')
                    addToast('Store added successfully', {
                        appearance: 'success',
                        autoDismiss: true,
                        autoDismissTimeout: 3000,
                    });
                }
            }
        } catch (error: any) {
            setSubmitClicked(false)
            console.error('error', error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    // INFO:- function to set the select list in cites
    const handleCiteListChange = (stateValue: { stateID: number | undefined }, regionId: number) => {
        // Determine which city list to use based on the region of the selected state
        const useKuwaitCities = regionId !== Region_List[0]?.stateID;

        // Filter the relevant city list based on the selected state's ID
        const filteredCities = (useKuwaitCities ? Kuwait_City_List : City_List)?.filter(
            (city) => city?.stateID === stateValue?.stateID
        );

        // Update the cities dropdown/options
        setCities(filteredCities);
    }
    // end

    // INFO:-function to handle the change of state or setTerritoryList list
    const handleChangeRegion = (value: number) => {
        if (!value) return
        setCities([])
        return value === Region_List[0].stateID ? setTerritoryList(State_List) : setTerritoryList(Kuwait_State_List)
    };
    // end

    // INFO:- function to handle the change of state/Governorate
    const handleStateGovernorateChange = (stateValue: any) => {
        // Update the store details with the new state and reset the city
        setStoreDetails((prevState: any) => ({
            ...prevState,
            state: stateValue,
            city: "",
        }));

        if (stateValue) {
            handleCiteListChange(stateValue, storeDetails?.region?.stateID)
        }
    };
    // end

    const getStoreDetails = async () => {
        try {
            const res = await service.store.getStoreByID(params?.id || '')
            if (res.status === 200) {
                let response: any = res?.data?.data
                const constForState = response?.region === 1 ? State_List : Kuwait_State_List
                const constForCity = response?.region === 1 ? City_List : Kuwait_City_List

                setImagesURL(response?.images)
                setBannerImagesURL(response?.store_banner || [])
                setStoreDetails({
                    store_id: response.store_id_display,
                    store_code: response?.store_code,
                    store_count: response.store_id_display.slice(-3),
                    store_name: response?.store_name,
                    store_contact_number: response?.store_contact_number,
                    store_address: response?.store_address,
                    store_location: response?.store_location,
                    city: {
                        value: getDropdownValue(constForCity, response?.city).value,
                        label: getDropdownValue(constForCity, response?.city).label,
                    },
                    store_images: response?.images,
                    store_banner: response?.store_banner || [],
                    cover_index: response?.cover_index,
                    state: {
                        value: getDropdownValue(constForState, response?.state).value,
                        label: getDropdownValue(constForState, response?.state).label,
                    },
                    admin_username: response?.store_admin?.login_id,
                    admin_password: '******',
                    admin_name: response?.store_admin?.username,
                    store_admin_id: response?.store_admin?.id,
                    pin_code: response?.pin_code,
                    owner_name: response?.owner_name,
                    owner_mobile: response?.owner_mobile,
                    owner_email: response?.owner_email,
                    owner_is_manager: response?.owner_is_manager.toString(),
                    manager_name: response?.manager_name,
                    manager_mobile: response?.manager_mobile,
                    manager_email: response?.manager_email,
                    legal_status: {
                        value: getDropdownValue(Store_Legal_Status, response?.legal_status)?.value,
                        label: getDropdownValue(Store_Legal_Status, response?.legal_status)?.label
                    },
                    tds: response?.tds,
                    credit: response?.credit,
                    latitude: response?.latitude,
                    longitude: response?.longitude,
                    opening_time: response?.opening_time,
                    closing_time: response?.closing_time,
                    bank_name: response?.bank_details?.bank_name,
                    ifsc_code: response?.bank_details?.ifsc_code,
                    account_number: response?.bank_details?.account_number,
                    total_staffs: response?.total_staffs,
                    additional_charge: response?.additional_charge,
                    furniture_type: {
                        value: getDropdownValue(constant.STORE_FURNITURE_TYPE, response?.furniture_type).value,
                        label: getDropdownValue(constant.STORE_FURNITURE_TYPE, response?.furniture_type).label
                    },
                    optometrist_available: response?.optometrist_available?.toString(),
                    chair_unit_available: response?.chair_unit_available?.toString(),
                    ar_machine_available: response?.ar_machine_available?.toString(),
                    lensometer_available: response?.lensometer_available?.toString(),
                    slit_lamp: response?.slit_lamp?.toString(),
                    gst_type: response?.gst_type,
                    is_warehouse: false,
                    head_office: response?.head_office,
                    at_your_service_since: response?.at_your_service_since,
                    google_rating: response?.google_rating,
                    online_commission_percent: response?.online_commission_percent,
                    number_of_subadmins: response?.number_of_subadmins,
                    number_of_staff: response?.number_of_staff,
                    region: {
                        value: getDropdownValue(Region_List, response?.region).value,
                        label: getDropdownValue(Region_List, response?.region).label,
                        stateID: response?.region
                    },
                    admin_permissions: response?.store_admin?.permissions?.map((item: { perm_code: string }) => item?.perm_code),
                    staff_permissions: response?.staff_permission,
                    website_url: response?.website_url,
                    role_id:response?.store_admin?.role?.id,
                    staff_permission_role_id:response?.staff_permission_role_id,
                    ar_store_address:response?.ar_store_address,
                    ar_store_name:response?.ar_store_name
                });
                //for store role
                response?.store_admin?.role && setSelectedRole({
                    key:response?.store_admin?.role?.id,
                    label:response?.store_admin?.role?.role_name,
                    value:response?.store_admin?.role?.id
                })
                //for staff role
                response?.store_admin?.role && setStaffSelectedRole({
                    key:response?.staff_permission_role_id?.id,
                    label:response?.staff_permission_role_id?.role_name,
                    value:response?.staff_permission_role_id?.id
                })
                setDefaultPermission(response?.store_admin?.permissions);
                setDefaultStaffPermission(modifiedStaffPermission(response?.staff_permissions))
                setUpdateStoreLocation(response?.store_location)
                printObjectsByDocType(response?.store_documents)
                await handleChangeRegion(response?.region)
                setAdminVerification((prevState)=>({
                    ...prevState,
                    admin_username:response?.store_admin?.login_id ?? '',
                    isAdminExist:true
                }))
                handleCiteListChange({
                    stateID: getStateIdByLabel(constForState, response?.state)
                }, response?.region)
            }
        } catch (error) {
            console.error('error', error)
        }
    }
    const printObjectsByDocType = (apiResponse: any) => {

        setStoreDetails((prevState: any) => {
            const updatedState = { ...prevState };

            apiResponse.forEach((item: any) => {
                const { doc_type, url } = item;
                switch (doc_type) {
                    case "GST":
                        updatedState.gst_number = item.doc_number;
                        updatedState.gst_document = url;
                        break;
                    case "PAN":
                        updatedState.pan_number = item.doc_number;
                        updatedState.pan_document = url;
                        break;
                    case "GUMASTA":
                        updatedState.gumasta_number = item.doc_number;
                        updatedState.gumasta_document = url;
                        break;
                    case "NAGAR_NIGAM":
                        updatedState.nagar_nigam_number = item.doc_number;
                        updatedState.nagar_nigam_document = url;
                        break;
                    case "INCORPORATION":
                        updatedState.incorporation_number = item.doc_number;
                        updatedState.incorporation_document = url;
                        break;
                    case "AGENCY":
                        updatedState.agency_number = item.doc_number;
                        updatedState.agency_document = url;
                        break;
                    default:
                        // Handle any other doc_type if needed
                        break;
                }
            });

            return updatedState;
        });

    }
    // for store permission
    const getStructuredPermission = async () => {
        try {
            const response = await service.permission.structuredPermission({
                for_store_portal: true,
            })
            if (response.status === 200) {
                setStructuredPermission(response.data.data)
                !params?.id && setDefaultPermission(response.data.data)
            }
        } catch (error) {
            console.error(error)
        }
    }
    // end

    // for store permission
    const getStructuredStaffPermission = async () => {
        try {
            const response = await service.permission.structuredPermission({
                for_staff_portal: true,
            })
            if (response.status === 200) {
                setStructuredStaffPermission(response.data.data)
                !params?.id && setDefaultStaffPermission(response.data.data)
            }
        } catch (error) {
            console.error(error)
        }
    }
    // end

    // to get the role list
    const getRolesList = async (value:number, storeRole:(value:any)=>void, storeRoleData:(value:any)=>void) => {
        try {
            let response = await service.roles.list({ role_for:value })
            storeRoleData(response?.data?.data)
            let list = response.data.data.map((item: any) => {
                return {
                    key: item.id,
                    value: item.role_name,
                    label: item.role_name,
                }
            })
            storeRole(list)
        } catch (error) {
            console.error(error)
        }
    };
    //end


    useEffect(() => {
        if (params?.id) {
            getStoreDetails()
        }
        getStructuredPermission();
        getStructuredStaffPermission()
        getRolesList(constant.ROLE_FOR[1].value,setRolesList,setRolesData);
        getRolesList(constant.ROLE_FOR[3].value,setStaffRolesList,setStaffRolesData);
    }, [])

    const validate = () => {
        let newErrors: any = {};

        if (step === 0) {
            for (const field in validationRulesStepOne) {
                if (validationRulesStepOne.hasOwnProperty(field)) {
                    // General validation
                    // if (!((storeDetails.owner_is_manager === 'true') && (field === 'manager_name' || field === 'manager_mobile' || field === "manager_email"))) {
                    if (validationRulesStepOne[field]?.required && !storeDetails[field]) {
                        newErrors[field] = "This field is required.";
                    } else if ((validationRulesStepOne[field]?.label?.required) && (!storeDetails[field]?.label)) {
                        newErrors[field] = "Please Select field";
                    } else if ((validationRulesStepOne[field][0]?.label?.required) && (!storeDetails[field][0]?.label)) {
                        newErrors[field] = "Please Select field";
                    } else if (storeDetails[field]?.length === 0 && imagesURL?.length === 0 && field !== "opening_time" && field !== "closing_time" && field !== 'latitude' && field !== 'longitude') {
                        newErrors[field] = "Please upload Images";
                    } else if (validationRulesStepOne[field]?.minLength < 10) {
                        newErrors[field] = `Maximum length is ${validationRulesStepOne[field].minLength}`;
                    } else if (!emailValidation(storeDetails.owner_email)) {
                        newErrors.owner_email = "Invalid Email";
                        setEmailError((prevErrors: any) => ({
                            ...prevErrors, owner_email: "Invalid Email"
                        }));
                    } else if (!emailValidation(storeDetails.manager_email)) {
                        newErrors.manager_email = "Invalid Email";
                        setEmailError((prevErrors: any) => ({
                            ...prevErrors, manager_email: "Invalid Email"
                        }));
                    } else if (validationRulesStepOne[field]?.required && field === "store_location" && errors?.store_location) {
                        newErrors.store_location = errors?.store_location;
                    }
                    // }

                    // Opening and Closing Time validation
                    if (field === "opening_time") {
                        if (storeDetails.closing_time && !storeDetails.opening_time) {
                            newErrors.opening_time = "Store Open Time is required if Store Close Time is provided.";
                        } else if (storeDetails.opening_time && storeDetails.closing_time && storeDetails.opening_time > storeDetails.closing_time) {
                            newErrors.closing_time = "Opening time should be earlier.";
                        }
                    } else if (field === "closing_time") {
                        if (storeDetails.opening_time && !storeDetails.closing_time) {
                            newErrors.closing_time = "Store Close Time is required if Store Open Time is provided.";
                        } else if (storeDetails.opening_time && storeDetails.closing_time && storeDetails.opening_time > storeDetails.closing_time) {
                            newErrors.closing_time = "Opening time should be earlier.";
                        }
                    }

                    // Latitude and Longitude validation
                    if (field === "latitude") {
                        if (storeDetails.longitude && !storeDetails.latitude) {
                            newErrors.latitude = "Latitude is required if Longitude is provided.";
                        } else if (storeDetails.latitude && !constant.LatitudeRegex.test(storeDetails.latitude)) {
                            newErrors.latitude = "Latitude must be between -90 and 90";
                        } else if (storeDetails.latitude && !constant.NumberValidationRegex.test(storeDetails.latitude)) {
                            newErrors.latitude = "Latitude must be a valid number.";
                        }
                    } else if (field === "longitude") {
                        if (storeDetails.latitude && !storeDetails.longitude) {
                            newErrors.longitude = "Longitude is required if Latitude is provided.";
                        } else if (storeDetails.longitude && !constant.LongitudeRegex.test(storeDetails.longitude)) {
                            newErrors.longitude = "Longitude must be between -180 and 180.";
                        } else if (storeDetails.longitude && !constant.NumberValidationRegex.test(storeDetails.longitude)) {
                            newErrors.longitude = "Longitude must be a valid number.";
                        }
                    }

                }
            }
            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
        } else if (step === 2) {
            return Object.keys(newErrors).length === 0;
        } else if (step === 3) {
            return Object.keys(newErrors).length === 0;
        } else if (step === 1) {
            for (const field in validationRulesStepTwo) {
                if (validationRulesStepTwo.hasOwnProperty(field)) {
                    if (validationRulesStepTwo[field]?.required && !storeDetails[field]) {
                        newErrors[field] = "This field is required.";
                    } else if ((validationRulesStepTwo[field]?.label?.required) && (!storeDetails[field]?.label)) {
                        newErrors[field] = "Please Select field";
                    } else if (!validationRulesStepTwo[field]?.valid && storeDetails[field]?.length === 0 && imagesURL?.length === 0) {
                        newErrors[field] = "Please upload Images";
                    }
                    // Email validation logic (commented out for now)
                    // if (validationRulesStepTwo[field]?.valid && storeDetails[field]) {
                    //     if (field === "admin_email") {
                    //         let error = validationRulesStepTwo[field]?.pattern.test(storeDetails[field])
                    //         if (!error) {
                    //             newErrors[field] = "Invalid Field";
                    //             setEmailError((prevErrors: any) => ({
                    //                 ...prevErrors, admin_email: "Invalid Email"
                    //             }));
                    //         }
                    //     }
                    // }
                    if (!params.id && !storeDetails.admin_password) {
                        newErrors.admin_password = "This field is required.";
                    }
                }
            }
            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
        } else if (step === 4) {
            for (const field in validationRulesStepThree) {
                if (validationRulesStepThree.hasOwnProperty(field)) {
                    if (!((storeDetails.gst_type === constant.GST_DETAILS.NA) && (field === 'gst_number' || field === 'gst_document'))) {
                        if (validationRulesStepThree[field]?.required && !storeDetails[field]) {
                            newErrors[field] = "This field is required.";
                        } else if (storeDetails[field]?.length === 0 && imagesURL?.length === 0) {
                            newErrors[field] = "Please Select Document";
                        }
                    }
                }
            }
            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
        }
    };

    const handleNextStep = () => {
        const isValid = validate();
        if (errors?.store_location && ((updateStoreLocation?.trim() != errors?.store_location?.trim()))) {
            addToast(errors?.store_location, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        } else {
            if (isValid) {
                return true
            }
        }
        return false
    }

    const handleChangePassword = async () => {
        let payload = {
            user_id: storeDetails.store_admin_id,
            password: storeDetails.admin_change_password
        }
        try {
            let response = await service.store.changePassword(payload)
            if (response.status === 200) {
                addToast('Password Change successfully', {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
                setStoreDetails({ ...storeDetails, admin_change_password: '' })
            }
        } catch (error) {

        }
    }

    const emailValidationMessage = (email: string, name: string) => {
        if (!emailValidation(email)) {
            setEmailError({ ...emailError, [name]: "Invalid Email" });
        } else {
            setEmailError({ ...emailError, [name]: "" });
        }
    };

    // function for selecting role in step 3
    const handleSelectedRole = async (role: TRoleOptional) => {
        setSelectedRole(role)
        setStoreDetails((prevState:any)=>({...prevState, role_id:role?.key}))
        rolesData?.forEach(async(item) => {
            if (item.id === role?.key) {
              const flatPermissions = await extractDefaultPermissions(item.permissions);
              setDefaultPermission(flatPermissions);
            }
          });
    }
    // end

    // function for selecting role in step 3
    const handleStaffSelectedRole = async (role: TRoleOptional) => {
        setStaffSelectedRole(role)
        setStoreDetails((prevState:any)=>({...prevState, staff_permission_role_id:role?.key}))
        staffRolesData?.forEach(async(item) => {
            if (item.id === role?.key) {
            const flatPermissions = await extractDefaultPermissions(item.permissions);
                setDefaultStaffPermission(flatPermissions);
            }
        });
    };
    // end

    return (
        <Wrapper>
            <div className='row align-items-center'>
                <TopBar heading={''} />
            </div>
            {storeDetails && <>
                <Stepper
                    steps={steps}
                    step={step}
                />
                <AddStoreOrganism
                    selectedRole={selectedRole}
                    step={step}
                    setStoreDetails={setStoreDetails}
                    storeDetails={storeDetails}
                    imagesURL={imagesURL}
                    bannerImagesURL={bannerImagesURL}
                    errors={errors}
                    setImageDeleteId={setImageDeleteId}
                    imageDeleteID={imageDeleteID}
                    handleChangePassword={handleChangePassword}
                    handleEmailError={emailValidationMessage}
                    errorMessage={emailError}
                    setErrors={setErrors}
                    updateStoreLocation={updateStoreLocation}
                    defaultPermission={defaultPermission}
                    structuredPermission={structuredPermission}
                    setDefaultPermission={setDefaultPermission}
                    territoryList={territoryList}
                    handleChangeRegion={(value: number) => handleChangeRegion(value)}
                    cities={cities}
                    handleStateGovernorateChange={handleStateGovernorateChange}
                    rolesList={rolesList}
                    handleSelectedRole={(value: TRoleOptional) => handleSelectedRole(value)}
                    adminVerification={adminVerification}
                    setAdminVerification={setAdminVerification}
                    defaultStaffPermission={defaultStaffPermission}
                    structuredStaffPermission={structuredStaffPermission}
                    setDefaultStaffPermission={setDefaultStaffPermission}
                    handleStaffSelectedRole={(value: TRoleOptional)=>handleStaffSelectedRole(value)}
                    staffRolesList={staffRolesList}
                    selectedStaffRole={staffSelectedRole}
                />
                <BottomNav
                    handleNextStep={handleNextStep}
                    steps={steps}
                    handleSubmit={() => _handleSubmitBtnClick()}
                    setStep={setStep}
                    step={step}
                    handleCancel={() => navigate('/stores')}
                />
            </>}
        </Wrapper>
    )
}

export default AddStore